//

import React, { createContext, useContext, useState, useEffect } from "react";

// ------------------ CREATE CONTEXTS ------------------
const ModalContext = createContext();
const ThemeContext = createContext();

// ------------------ PROVIDER ------------------
export const AppProvider = ({ children }) => {
  // ------------------ MODAL STATES ------------------
  const [showModal, setShowModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [showJackpotInfo, setShowJackpotInfo] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showAgeVerification, setShowAgeVerification] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);

  // ------------------ THEME STATE ------------------
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const [device, setDevice] = useState({
    isMobile: window.innerWidth < 640,
    isTablet: window.innerWidth >= 640 && window.innerWidth <= 1024,
    isDesktop: window.innerWidth > 1024,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setDevice({
        isMobile: width < 640,
        isTablet: width >= 640 && width <= 1024,
        isDesktop: width > 1024,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // ------------------ BASE COLORS ------------------
  const isDark = theme === "dark";

  const baseColors = {
    modalBg: isDark ? "bg-[#1c1f24]" : "bg-gray-100",
    textColor: isDark ? "text-gray-200" : "text-gray-900",
    borderColor: isDark ? "border-gray-700" : "border-gray-300",
    inputBg: isDark ? "bg-[#2a2e35]" : "bg-[#dadada]",
    inputText: isDark ? "text-gray-100" : "text-gray-800",
    placeholder: isDark ? "placeholder-gray-500" : "placeholder-gray-400",
    buttonGradient:"bg-gradient-to-r from-emerald-400 to-blue-600 " ,
    buttonBg: isDark ? "bg-green-500" : "bg-green-500",
    buttonHover: isDark ? "hover:bg-green-600" : "hover:bg-green-600",
    infoText: isDark ? "text-gray-400" : "text-gray-500",
  };

  // ------------------ MODAL HANDLERS ------------------
  const onCloseInfo = () => setShowJackpotInfo(!showJackpotInfo);
  const onShowRegister = () => setShowRegister(!showRegister);
  const onShowLogin = () => setShowLogin(!showLogin);
  const onShowTutorial = () => setShowTutorial(!showTutorial);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, baseColors }}>
      <ModalContext.Provider
        value={{
          showModal,
          setShowModal,
          showDepositModal,
          setShowDepositModal,
          showJackpotInfo,
          onCloseInfo,
          showLogin,
          setShowLogin,
          onShowLogin,
          showRegister,
          setShowRegister,
          onShowRegister,
          showTutorial,
          setShowTutorial,
          onShowTutorial,
          showAgeVerification,
          setShowAgeVerification,
          device,

        }}
      >
        {children}
      </ModalContext.Provider>
    </ThemeContext.Provider>
  );
};

// ------------------ CUSTOM HOOKS ------------------

// Theme hook
export const useTheme = () => useContext(ThemeContext);

// Modal hooks
export const useModal = () => {
  const { showModal, setShowModal } = useContext(ModalContext);
  return { showModal, setShowModal };
};

export const useDepositModal = () => {
  const { showDepositModal, setShowDepositModal } = useContext(ModalContext);
  return { showDepositModal, setShowDepositModal };
};

export const useJackpotModal = () => {
  const { showJackpotInfo, onCloseInfo } = useContext(ModalContext);
  return { showJackpotInfo, onCloseInfo };
};

export const useShowLogin = () => {
  const { showLogin, setShowLogin, onShowLogin } = useContext(ModalContext);
  return { showLogin, setShowLogin, onShowLogin };
};

export const useShowRegister = () => {
  const { showRegister, setShowRegister, onShowRegister } = useContext(ModalContext);
  return { showRegister, setShowRegister, onShowRegister };
};
export const useShowAgeVerification = () => {
  const { showAgeVerification, setShowAgeVerification } = useContext(ModalContext);
  return { showAgeVerification, setShowAgeVerification,  };
};

export const useShowTutorial = () => {
  const { showTutorial, setShowTutorial, onShowTutorial } = useContext(ModalContext);
  return { showTutorial, setShowTutorial, onShowTutorial };
};
export const useDevice = () => {
  const { device } = useContext(ModalContext);
  return device; // gives { isMobile, isTablet, isDesktop }
};





/*********************************************************************************************************************/
// import React, { createContext, useContext, useState, useEffect } from "react";

// const ModalContext = createContext();
// const ThemeContext = createContext();

// export const AppProvider = ({ children }) => {
//   // ---------------- MODAL STATES ----------------
//   const [showModal, setShowModal] = useState(false);
//   const [showJackpotInfo, setShowJackpotInfo] = useState(false);
//   const [showRegister, setShowRegister] = useState(true);
//   const [showLogin, setShowLogin] = useState(false);
//   const [showTutorial, setShowTutorial] = useState(false);

//   const onCloseInfo = () => setShowJackpotInfo(!showJackpotInfo);
//   const onShowRegister = () => setShowRegister(!showRegister);
//   const onShowLogin = () => setShowLogin(!showLogin);
//   const onShowTutorial = () => setShowTutorial(!showTutorial);

//   // ---------------- THEME ----------------
//   const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

//   useEffect(() => {
//     localStorage.setItem("theme", theme);
//   }, [theme]);

//   const toggleTheme = () => {
//     setTheme(prev => (prev === "dark" ? "light" : "dark"));
//   };

//   // ---------------- BASE COLORS ----------------
//   const isDark = theme === "dark";
//   const baseColors = {
//     modalBg: isDark ? "bg-[#0f172a]" : "bg-gray-100",
//     textColor: isDark ? "text-white" : "text-gray-900",
//     borderColor: isDark ? "border-gray-800" : "border-gray-300",
//     inputBg: isDark ? "bg-gray-800" : "bg-white",
//     inputText: isDark ? "text-white" : "text-gray-900",
//     placeholder: isDark ? "placeholder-gray-400" : "placeholder-gray-500",
//     buttonBg: isDark ? "bg-[#00ff88]" : "bg-green-500",
//     buttonHover: isDark ? "hover:bg-green-600" : "hover:bg-green-600",
//     infoText: isDark ? "text-gray-400" : "text-gray-500",
//   };

//   return (
//     <ThemeContext.Provider value={{ theme, toggleTheme, baseColors }}>
//       <ModalContext.Provider
//         value={{
//           showModal,
//           setShowModal,
//           showJackpotInfo,
//           onCloseInfo,
//           showLogin,
//           setShowLogin,
//           onShowLogin,
//           showRegister,
//           setShowRegister,
//           onShowRegister,
//           showTutorial,
//           setShowTutorial,
//           onShowTutorial,
//         }}
//       >
//         {children}
//       </ModalContext.Provider>
//     </ThemeContext.Provider>
//   );
// };

// // ---------------- HOOKS ----------------
// export const useTheme = () => useContext(ThemeContext);

// export const useModal = () => useContext(ModalContext);
// export const useJackpotModal = () => {
//   const { showJackpotInfo, onCloseInfo } = useContext(ModalContext);
//   return { showJackpotInfo, onCloseInfo };
// };
// export const useShowLogin = () => useContext(ModalContext);
// export const useShowRegister = () => useContext(ModalContext);
// export const useShowTutorial = () => useContext(ModalContext);
